import { render } from "./fldSignature.vue?vue&type=template&id=2be8ae40"
import script from "./fldSignature.vue?vue&type=script&lang=js"
export * from "./fldSignature.vue?vue&type=script&lang=js"

import "./fldSignature.vue?vue&type=style&index=0&id=2be8ae40&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QField,QColor});
